import { NOTIFY_ERROR, NOTIFY_COMPLETE_CHECKOUT_ERROR, NOTIFY_DUPLICATEPO_CHECKOUT_ERROR, LOG_ERROR, DISMISS_MESSAGE } from '../../GlobalStateContainer'

/* ERROR */
let messageId = 0;

export function notifyError(message, diagnosticMessage) {
  diagnosticMessage && console.error(diagnosticMessage) && console.trace && console.trace();
  return { type: NOTIFY_ERROR, message, messageId: messageId++ }
}

export function notifyCompleteCheckoutError(message, diagnosticMessage) {
  diagnosticMessage && console.error(diagnosticMessage) && console.trace && console.trace();
  return { type: NOTIFY_COMPLETE_CHECKOUT_ERROR, message, messageId: messageId++ }
}

export function notifyDuplicatePOCheckoutError(message, diagnosticMessage) {
    diagnosticMessage && console.error(diagnosticMessage) && console.trace && console.trace();
    return { type: NOTIFY_DUPLICATEPO_CHECKOUT_ERROR, message, messageId: messageId++ }
}

export function logError(diagnosticMessage) {
  diagnosticMessage && console.error(diagnosticMessage) && console.trace && console.trace();
  return { type: LOG_ERROR, diagnosticMessage }
}

export function dismissMessage(messageId) {
  return { type: DISMISS_MESSAGE, messageId }
}


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/UserMessaging/messagesListActionCreators.js